import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import {statusSchedule} from '../view-agenda/view-agenda.component'
import { CommonModule } from '@angular/common';
import {format} from 'date-fns';
import { EditarAgendamentoComponent } from "./editar-agendamento/editar-agendamento.component";
import { EncaixeAgendamentoComponent } from "./encaixe-agendamento/encaixe-agendamento.component";
import { RemarcarAgendamentoComponent } from "./remarcar-agendamento/remarcar-agendamento.component";
@Component({
  selector: 'app-view-agendamento',
  standalone: true,
  imports: [CommonModule, EditarAgendamentoComponent, EncaixeAgendamentoComponent, RemarcarAgendamentoComponent],
  templateUrl: './view-agendamento.component.html',
  styleUrls: ['./view-agendamento.component.scss'],
})
export class ViewAgendamentoComponent  implements OnInit {
  @Output() closeModalAppointment: EventEmitter<void> = new EventEmitter();
  @Output() updateDataAppointment: EventEmitter<void> = new EventEmitter();

  @Input() objectData : any;
  @Input() arrFittings: any;


  public statusSchedule = statusSchedule;
  public appointMentsFittings: Array<any> = [];



  public openModalCancelarAgendamento: boolean = false;
  public openModalEncaixes: boolean = false;
  public objectDefaultInfoAppointment: any;

  public isOpenModalReeschedule: boolean = false;
  public selectedAppointmentToReeschedule!: any;

  constructor() { }

  ngOnInit() {
    this.objectDefaultInfoAppointment = {
      ...this.objectData
    }

    for(let item of this.arrFittings){
      this.appointMentsFittings.push(item);
    }

    //Correcoes de dados antes da renderizacao
    this.objectData.clientPhone = this.formatPhoneAppointment(this.objectData.clientPhone);
    
    this.appointMentsFittings.shift();
  }

  formatPhoneAppointment(phone: string){
    const numeros = phone.replace(/\D/g, '');
    if (numeros.length === 11) {
      return numeros.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
    }

    if (numeros.length === 10) {
      return numeros.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
    }
    
    return phone;
  }

  getStatusEnum(status: keyof typeof statusSchedule): string{
    return this.statusSchedule[status];
  }

  handleCloseModal(){
    this.closeModalAppointment.emit();
  }

  handleOpenModalCancelarAgendamento(){
    this.openModalCancelarAgendamento = true;
  }


  handleCloseSimpleModal(){
    this.openModalCancelarAgendamento = false;
  }

  handleFecharModalCancelarAgendamento(){
    this.updateDataAppointment.emit();
    this.openModalCancelarAgendamento = false;
  }


  handleOpenModalEncaixes(){
    this.openModalEncaixes  = true;
  }

  handleCloseModalEncaixes(){
    this.openModalEncaixes = false;
  }

  handleUpdateData(){
    this.updateDataAppointment.emit();
  }



  handleOpenModalReeschedule(itemRef: any){
    this.isOpenModalReeschedule = true;
    this.selectedAppointmentToReeschedule = itemRef;
  }

  handleCloseModalReeschedule(){
    this.isOpenModalReeschedule = false;
  }

  handleFecharModalReagendamento(){
    this.updateDataAppointment.emit();
    this.isOpenModalReeschedule = false;
  }

}
